<!--
 * @Description: 
--> 
<!--
 * @Description: 底部切换栏组件
--> 

<template>
  <div class="home-bar">
    <van-tabbar v-model="active" active-color="#258A37" route>
      <van-tabbar-item icon="home-o" to="/" replace>
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? icon.homeActive : icon.home" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="search" to="/business" replace>
        <span>业务办理</span>
        <template #icon="props">
          <img :src="props.active ? icon.businessActive : icon.business" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="friends-o" to="/butler" replace>
        <span>“水管家”服务</span>
        <template #icon="props">
          <img :src="props.active ? icon.butlerActive : icon.butler" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="setting-o" to="/personCenter" replace>
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? icon.mineActive : icon.mine" /> 
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'HomeBar',
  components: {
  },
  data() {
    return {
      active: 0,
      icon: {
        home: require('../assets/images/new-logo-circle.png'),
        homeActive: require('../assets/images/new-logo.png'),
        business: require('../assets/images/banli.png'),
        businessActive: require('../assets/images/banli-1.png'),
        butler: require('../assets/images/service.png'),
        butlerActive: require('../assets/images/service-1.png'),
        mine: require('../assets/images/mine.png'),
        mineActive: require('../assets/images/mine-1.png'),
      }
    }
  },
  mounted(){
  },
  methods: {
    onChange(index) {
      let path = ''
      if (index===0) {
        path = '/'
      } else if (index===1){
        path = '/business'
      } else if (index===2) {
        path = '/butler'
      } else {
        path = '/mine'
      }
      this.$router.push({
        path: path
      })
    },
  },
}
</script>

<style lang="less" scoped>
</style>